import React, { useEffect, useState } from 'react';
import {
    AddressActionMenu,
    AddressActionMenuItem,
    AddressActionMenuOverlay,
    AddressActionMenuWrap,
    NavigateAddressBtn,
} from './Roteiros.styles';

function buildGoogleMapsUrl(address) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

function buildWazeUrl(address) {
    return `https://waze.com/ul?q=${encodeURIComponent(address)}&navigate=yes`;
}

function NavigationIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <polygon points="3 11 22 2 13 21 11 13 3 11" />
        </svg>
    );
}

function ChevronDown({ open }) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
            style={{ transform: open ? 'rotate(180deg)' : undefined, transition: 'transform 0.15s' }}
        >
            <polyline points="6 9 12 15 18 9" />
        </svg>
    );
}

export default function OpenNavigationButton({ address }) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!open) return undefined;

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                setOpen(false);
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [open]);

    if (!address) return null;

    const openNavigation = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
        setOpen(false);
    };

    return (
        <AddressActionMenuWrap>
            <NavigateAddressBtn
                type="button"
                onClick={() => setOpen((value) => !value)}
                aria-expanded={open}
                aria-haspopup="menu"
                aria-label="Abrir endereço no mapa"
            >
                <NavigationIcon />
                Abrir no mapa
                <ChevronDown open={open} />
            </NavigateAddressBtn>

            {open ? (
                <>
                    <AddressActionMenuOverlay
                        aria-hidden
                        onClick={() => setOpen(false)}
                    />
                    <AddressActionMenu role="menu" aria-label="Escolher aplicativo de navegação">
                        <AddressActionMenuItem
                            type="button"
                            role="menuitem"
                            onClick={() => openNavigation(buildGoogleMapsUrl(address))}
                        >
                            Google Maps
                        </AddressActionMenuItem>
                        <AddressActionMenuItem
                            type="button"
                            role="menuitem"
                            onClick={() => openNavigation(buildWazeUrl(address))}
                        >
                            Waze
                        </AddressActionMenuItem>
                    </AddressActionMenu>
                </>
            ) : null}
        </AddressActionMenuWrap>
    );
}
